import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics';
import { useFetchParams } from 'hooks/useFetchParams';
import { useViewport } from 'utils/responsive';
import usePermissionHook from 'hooks/usePermissionHook';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { callValidateGSTDetails } from 'utils/api/services';
import { ValidateGSTDetailsResponse } from 'utils/api/types';
import { MPosContext } from 'utils/context';
import {
    SegmentEventNameTypes,
    SegmentEventActionTypes,
    SegmentEventButtonNames,
    PRODUCT,
    SUB_PRODUCT_NAME,
    SegmentEventActionNames,
} from 'utils/segment/constants';
import IconTextArrowCard from 'widgets/cards/iconTextArrow';
import * as Styles from './styles';

function NewPlan() {
    const router = useRouter();

    const { partnerId, userDetails, permissions, setGstDetailsValid } =
        useContext(MPosContext);
    const { lob } = useFetchParams();
    const { isMobile } = useViewport();

    const purchaseJourney = permissions.purchase_journey;

    const { getPartnerIdFromPermission } = usePermissionHook();

    const onClickNewPlan = async () => {
        const gstValidationResponse: ValidateGSTDetailsResponse =
            await callValidateGSTDetails(
                getPartnerIdFromPermission(),
                permissions.group,
                true
            );

        if (!gstValidationResponse.is_error) {
            if (gstValidationResponse.data) {
                const { required, valid } = gstValidationResponse.data;
                if (required && !valid) {
                    setGstDetailsValid(false);
                    return;
                }
                setGstDetailsValid(true);
            }
        }
        router.push(`/${lob}/${userDetails.partner_id}/new-plan`);
        /**
         * Segment event
         */
        trackEvent(SegmentEventNameTypes.ACTION, {
            page_url: window?.location?.href || '',
            action_type: SegmentEventActionTypes.TAP_BTN,
            button_name: SegmentEventButtonNames.CREATE_NEW_PLAN,
            product: PRODUCT,
            sub_product: SUB_PRODUCT_NAME,
            platform: isMobile ? 'mweb' : 'web',
            device: navigator.userAgent || '',
            partner: partnerId,
            action_name: SegmentEventActionNames.CREATE_NEW_PLAN,
        });
    };

    return (
        <Styles.NewPlanWrapper>
            <IconTextArrowCard
                icon={
                    purchaseJourney === 'v1'
                        ? '/icons/note.svg'
                        : '/icons/claim.svg'
                }
                text={'Create new plan'}
                backgroundColor={'161.3deg, #FFF7E5 -2.04%, #FBE9F6 102.81%'}
                onClick={onClickNewPlan}
                iconBackground={
                    purchaseJourney === 'v1'
                        ? 'transparent'
                        : '161.3deg, #FFF7E5 -2.04%, #FBE9F6 102.81%'
                }
            />
        </Styles.NewPlanWrapper>
    );
}

export default NewPlan;
